const introData = [
  {
    lang: "fr",
    titreImage: "titre",
    nameTagImage: "nameTag",
    buttonIntro: `Démarrer l’aventure`,
    buttonDeb: "Débutant",
    buttonExp: `Expert`,
    ageDeb: "6 – 8 ans",
    ageExp: "9 - 11 ans",
    videoKey: "introVideo",
  },
  {
    lang: "en",
    titreImage: "titre-en",
    nameTagImage: "nameTag-en",
    buttonIntro: `Start the Adventure`,
    buttonDeb: "Beginner",
    buttonExp: `Expert`,
    ageDeb: "6–8 years",
    ageExp: "9–11 years",
    videoKey: "introVideo-en",
  },
];

export default introData;
